import { render, staticRenderFns } from "./SideSteps-v2.vue?vue&type=template&id=c07688f0&scoped=true&"
import script from "./SideSteps-v2.vue?vue&type=script&lang=js&"
export * from "./SideSteps-v2.vue?vue&type=script&lang=js&"
import style0 from "./SideSteps-v2.vue?vue&type=style&index=0&id=c07688f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07688f0",
  null
  
)

export default component.exports